import { createTheme, MantineColorsTuple } from '@mantine/core';

// ---------------------------------------------------------------------------
//  Brand Palette — Deep Ocean Teal
// ---------------------------------------------------------------------------

const brand: MantineColorsTuple = [
  '#e6fbf3',
  '#d0f4e4',
  '#a3e8c8',
  '#72dbaa',
  '#4ad091',
  '#2fc980',
  '#21c578',
  '#12ae65',
  '#009b59',
  '#00864b',
];

const amber: MantineColorsTuple = [
  '#fff8e1',
  '#ffecb3',
  '#ffe082',
  '#ffd54f',
  '#ffca28',
  '#ffc107',
  '#ffb300',
  '#ffa000',
  '#ff8f00',
  '#ff6f00',
];

const slate: MantineColorsTuple = [
  '#f5f5f7',
  '#e8e8ec',
  '#d1d1d9',
  '#b5b5c1',
  '#9d9dac',
  '#84849a',
  '#6e6e86',
  '#55566b',
  '#3e3f52',
  '#1a1b23',
];

// ---------------------------------------------------------------------------
//  Theme
// ---------------------------------------------------------------------------

export const theme = createTheme({
  primaryColor: 'brand',
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  headings: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeight: '700',
  },
  colors: {
    brand,
    amber,
    slate,
  },
  defaultRadius: 'md',
  cursorType: 'pointer',
  shadows: {
    xs: '0 1px 2px rgba(0,0,0,0.04)',
    sm: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
    md: '0 4px 6px -1px rgba(0,0,0,0.07), 0 2px 4px -1px rgba(0,0,0,0.04)',
    lg: '0 10px 15px -3px rgba(0,0,0,0.08), 0 4px 6px -2px rgba(0,0,0,0.04)',
    xl: '0 20px 25px -5px rgba(0,0,0,0.08), 0 10px 10px -5px rgba(0,0,0,0.03)',
  },
  components: {
    Paper: {
      defaultProps: {
        shadow: 'sm',
        radius: 'md',
        p: 'md',
      },
    },
    Button: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        root: {
          fontWeight: 600,
          transition: 'all 150ms ease',
        },
      },
    },
    Modal: {
      defaultProps: {
        radius: 'lg',
        centered: true,
        overlayProps: { backgroundOpacity: 0.35, blur: 4 },
        shadow: 'xl',
      },
    },
    Table: {
      styles: {
        th: {
          fontSize: '0.7rem',
          fontWeight: 700,
          textTransform: 'uppercase' as const,
          letterSpacing: '0.05em',
          color: 'var(--mantine-color-dimmed)',
        },
      },
    },
    NavLink: {
      styles: {
        root: {
          borderRadius: 'var(--mantine-radius-md)',
          transition: 'all 150ms ease',
        },
      },
    },
    Badge: {
      defaultProps: {
        radius: 'sm',
        variant: 'light',
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    Select: {
      defaultProps: {
        radius: 'md',
      },
    },
    AppShell: {
      styles: {
        main: {
          backgroundColor: 'light-dark(var(--mantine-color-slate-0), var(--mantine-color-dark-8))',
        },
      },
    },
    Card: {
      defaultProps: {
        shadow: 'sm',
        radius: 'md',
      },
    },
    Skeleton: {
      defaultProps: {
        radius: 'md',
      },
    },
  },
});
